export default "__VITE_ASSET__a5801dc2__"